import Divided from "components/organisms/common/Divided"
import ScrollAnimate from "components/atoms/common/ScrollAnimate"
import useTranslations from "hooks/useTranslations"
import { TogetherImage } from "./images"
import LoginButton from "./LoginButton"

/**
 * Three numbered steps for parents and children, in the same shape as the UK
 * schools page's Journey section. The draft suggests a carousel here; this is
 * the static version until visuals for each step exist.
 */
export default function ParentInfoTogether() {
  const {
    parentInfoTogetherTitle,
    parentInfoTogetherNames,
    parentInfoTogetherTexts,
  } = useTranslations()

  const names: string[] = parentInfoTogetherNames || []
  const texts: string[] = parentInfoTogetherTexts || []

  return (
    <Divided
      Image={TogetherImage}
      title={parentInfoTogetherTitle}
      theme="green"
      titleSize="lg"
      reversed
      fullHeight={false}
      listLength={6}
      // Divided's tallest preset (39rem) is shorter than three long steps
      // plus the login button. The content carries the same minimum so the
      // band grows with the photo instead of letting it spill into the next.
      imageClassName="lg:!h-[46rem]"
      contentClassName="lg:min-h-[46rem]"
    >
      <div>
        <ol className="m-0 list-none space-y-8 p-0">
          {names.map((name, index) => (
            <ScrollAnimate key={name} delay={index * 0.08}>
              <li className="flex items-start gap-4">
                {/* A fixed-size badge, so every step's text starts at the same
                    x. 2rem matches the title's lg line height (text-2xl), which
                    centres the badge on the title's first line. */}
                <span
                  aria-hidden="true"
                  className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-zinc-900 font-display text-base font-semibold leading-none text-white"
                >
                  {/* Gramatika's ascent exceeds its descent, so a centred line
                      box leaves digits slightly above the circle's centre. */}
                  <span className="translate-y-[0.05em]">{index + 1}</span>
                </span>
                <div>
                  <h3 className="m-0 mb-2 font-display text-xl font-semibold text-zinc-900 lg:text-2xl">
                    {name}
                  </h3>
                  <p className="m-0 text-base leading-snug text-zinc-800">
                    {texts[index] || ""}
                  </p>
                </div>
              </li>
            </ScrollAnimate>
          ))}
        </ol>
        {/* Step 1 is "Log in & Explore Together", so the steps end on it. */}
        {/* Same entrance as the steps, one beat after the last of them. */}
        <ScrollAnimate delay={names.length * 0.08} className="mt-10">
          <LoginButton />
        </ScrollAnimate>
      </div>
    </Divided>
  )
}
